import { ArrowLeftRightIcon, CloudFogIcon, DropletIcon, FlameIcon, ThermometerIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '01',
    title: 'Heat & Steam Fundamentals: Heat Transfer, Steam Properties & Plant Utilities',
    summary: 'A visual technical reference to how heat moves, how steam behaves and how plant utilities deliver energy where it is needed.',
    icon: ThermometerIcon,
  },
  {
    number: '02',
    title: 'Industrial Boilers: Types, Components, Fuels & Combustion',
    summary: 'A visual technical reference to how industrial boilers are built, fired and made to burn fuel cleanly and efficiently.',
    icon: FlameIcon,
  },
  {
    number: '03',
    title: 'Boiler Water Treatment, Controls & Safety Devices',
    summary: 'A visual technical reference to keeping boiler water clean, boiler levels under control and every safety device ready to act.',
    icon: DropletIcon,
  },
  {
    number: '04',
    title: 'Steam Distribution, Steam Traps & Condensate Recovery',
    summary: 'A visual technical reference to delivering dry steam to every user and bringing every kilogram of condensate home.',
    icon: CloudFogIcon,
  },
  {
    number: '05',
    title: 'Heat Exchangers: Types, Thermal Principles & Performance',
    summary: 'A visual technical reference to how heat exchangers are built, how they transfer heat and how their performance is measured.',
    icon: ArrowLeftRightIcon,
  },
  {
    number: '06',
    title: 'Inspection, Maintenance, Cleaning & Troubleshooting',
    summary: 'A visual technical reference to keeping boilers and heat exchangers safe, clean, efficient and reliable.',
    icon: WrenchIcon,
  },
];
